import { render, staticRenderFns } from "./identityInfo.vue?vue&type=template&id=e09ba95c&scoped=true&"
import script from "./identityInfo.vue?vue&type=script&lang=js&"
export * from "./identityInfo.vue?vue&type=script&lang=js&"
import style0 from "./identityInfo.vue?vue&type=style&index=0&id=e09ba95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09ba95c",
  null
  
)

export default component.exports